import CoVTemperatureField from './CoVTemperatureField'

export default CoVTemperatureField
